import { Model } from '@models/core/base.model';
import { ChangeRequestTemplateField } from '@models/change-requests/change-request-template-field.model';

export class ChangeRequestFieldValue extends Model {
    protected static _serializeAttributes = ['humiChangeRequestFieldId', 'newValue', 'isUpdated'];

    get field() {
        return this.hasOne(ChangeRequestTemplateField, 'field');
    }

    get humiChangeRequestFieldId(): number {
        return this._attributes['humiChangeRequestFieldId'];
    }

    set humiChangeRequestFieldId(val: number) {
        this._attributes['humiChangeRequestFieldId'] = val;
    }

    get newValue(): string {
        return this._attributes['newValue'];
    }

    set newValue(val: string) {
        this._attributes['newValue'] = val;
    }

    get oldValue(): any {
        return this._attributes['oldValue'];
    }

    get isUpdated(): boolean {
        return !!this._attributes['isUpdated'];
    }

    set isUpdated(val: boolean) {
        this._attributes['isUpdated'] = val;
    }
}
